<template>
    <div class="w-100 modal-thing px-2">
        <div class="d-none d-md-flex justify-content-center mb-5 pb-4">
            <img :src="educationImage" style="max-width: 300px" class="mx-auto" />
        </div>

        <div class="mb-4 text-center">
            <p class="font-weight-bold font-size-200 mb-0">{{ translate('Claim educational access') }}</p>
        </div>

        <div
            class="bg-education text-white py-2 px-4 text-center d-flex align-items-center justify-content-between gap-75 br-4 mb-4"
        >
            <div class="d-inline-flex justify-content-center align-items-center gap-75 flex-wrap">
                <i class="far fa-graduation-cap font-size-200"></i>

                <span v-html="description"></span>

                <div class="gap-75 d-inline-flex align-items-center justify-content-center flex-wrap">
                    <a :href="linkEducation" class="text-white text-underline">{{ translate('Learn more') }}</a>
                </div>
            </div>
        </div>

        <ButtonWithLoadingState
            class="btn btn-warning btn-lg btn-block font-weight-bold text-uppercase rounded"
            :text="translate('Claim now')"
            :is-state-loading="stateLoading"
            @click.stop.prevent="claimEducational"
        ></ButtonWithLoadingState>
    </div>
</template>

<script>
import ButtonWithLoadingState from '../../../../../qaamgo/modules/sat/components/form/ButtonWithLoadingState.vue';
import TransFilter from '../../../../../qaamgo/modules/sat/components/mixins/TransFilter.vue';
import { User } from '../../../user';
import { userManager } from '../../../user-manager';
import { pageNotification } from '../../../../../qaamgo/helper/notify';

export default {
    name: 'ClaimEducationView',
    components: { ButtonWithLoadingState },
    mixins: [TransFilter],
    props: {
        data: {
            type: User | null,
            default: null,
        },
    },
    computed: {
        educationImage() {
            return window.sat.educationImageAssetUrl;
        },
        linkEducation() {
            return window.sat.educationUrl;
        },
        description() {
            return this.translate(
                'Your email address belongs to a school and you are eligible for a <strong>free educational premium account.</strong>'
            );
        },
    },
    methods: {
        async claimEducational() {
            this.stateLoading = true;

            try {
                await userManager.claimEducationalAccessAndRedirectToSuccessPage();
            } catch (e) {
                pageNotification.showGenericErrorMessage();
            } finally {
                setTimeout(() => {
                    this.stateLoading = false;
                }, 5000);
            }
        },
    },
    data() {
        return {
            stateLoading: false,
        };
    },
};
</script>

<style scoped>
.modal-thing {
    max-width: 480px;
}
</style>
